/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import EpisodePosterCover from '../../../../assets/images/1080p/hydra_image_black_background.png';
import MoviePosterCover from '../../../../assets/images/1080p/hydra_image_black_background_2x3.png';
import ParentalCover from '../../../../assets/images/pc_locked_16x9.png';
import { Locale, LocaleKeys } from '../../../../core/locale';
import { ImageLoader } from '../../../ImageLoader';
import { ImageLoaderTypes } from '../../../ImageLoader/ImageLoaderTypes';

import './PreviewImage.scss';

type PreviewImageProps = {
    src: string;
    isAdult: boolean;
    isMovie: boolean;
    fallbackText: string;
};

const PreviewImage: FunctionComponent<PreviewImageProps> = (props) => {
    const { src, isAdult, isMovie, fallbackText } = props;

    const [imageSrc, setImageSrc] = useState<string>(isAdult ? ParentalCover : src);
    const [isFallbackImage, setIsFallbackImage] = useState<boolean>(false);
    const fallbackTextRef = useRef<HTMLSpanElement>(null);

    let imageClasses = '';
    if (isMovie && !isAdult) {
        imageClasses = ' recording-movie-poster';
    }
    if (isFallbackImage) {
        imageClasses += ` ${isMovie ? 'preview-movie-fallback-image' : 'preview-fallback-image'}`;
    }

    const isOverflowed =
        (fallbackTextRef.current?.scrollHeight || 0) > (fallbackTextRef.current?.clientHeight || 0);

    useEffect(() => {
        // when-ever any prop change reset the state
        setImageSrc(isAdult ? ParentalCover : src);
        setIsFallbackImage(false);
    }, [props]);

    return (
        <div
            className={`myshows-preview-image${isMovie && !isAdult ? ' recording-movie-poster' : ''}`}
        >
            <ImageLoader
                src={imageSrc}
                imageType={`${ImageLoaderTypes.RECORDING_PREVIEW_IMAGE}${imageClasses}`}
                handleOnImageLoaded={(isImageLoaded: boolean) => {
                    if (!isImageLoaded && !isFallbackImage) {
                        setImageSrc(isMovie ? MoviePosterCover : EpisodePosterCover);
                        setIsFallbackImage(true);
                    }
                }}
            />
            {(isAdult || isFallbackImage) && (
                <span
                    ref={fallbackTextRef}
                    className={`preview-image-text${isAdult ? ' title-hidden' : ''}${isOverflowed ? ' overflow' : ''}`}
                >
                    {isAdult ? Locale.getString(LocaleKeys.GUIDE_TITLE_HIDDEN) : fallbackText}
                </span>
            )}
        </div>
    );
};

export default PreviewImage;
